import { IOHelper, utils } from '@neo-one/client-common';
import { ContractParameterBase } from './ContractParameterBase';
import { ContractParameterType } from './ContractParameterType';
export class BooleanContractParameter extends ContractParameterBase {
    constructor(value) {
        super();
        this.type = ContractParameterType.Boolean;
        this.value = value;
        this.sizeInternal = utils.lazy(() => IOHelper.sizeOfBoolean);
    }
    static deserializeWireBase(options) {
        const { reader } = options;
        super.deserializeContractParameterBaseWireBase(options);
        const value = reader.readBoolean();
        return new this(value);
    }
    get size() {
        return this.sizeInternal();
    }
    asBuffer() {
        return this.value ? BooleanContractParameter.TRUE : BooleanContractParameter.FALSE;
    }
    asBoolean() {
        return this.value;
    }
    serializeWireBase(writer) {
        super.serializeWireBase(writer);
        writer.writeBoolean(this.value);
    }
    serializeJSON(_context) {
        return {
            type: 'Boolean',
            value: this.value,
        };
    }
}
BooleanContractParameter.TRUE = Buffer.from([1]);
BooleanContractParameter.FALSE = Buffer.from([0]);

//# sourceMappingURL=BooleanContractParameter.js.map
